import { render } from "./Permissions.vue?vue&type=template&id=70da9f6e&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=70da9f6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70da9f6e"]])

export default __exports__